import React, { useEffect, useState } from 'react';

import { Box, CircularProgress } from '@mui/material';

import { callGetFeatureJson } from 'handimap-react-lib/api/jsonFeatureApi';
import { SelectedFeatureLineDetails } from './SelectedFeatureLineDetails';
import { SelectedFeaturePointDetails } from './SelectedFeaturePointDetails';

const profilAttributeAccessMapping = {
  'Déficience motrice': {
    'label-th': 'labelthmot',
    'acc-key': 'amot',
    'desc-th': 'descthmot'
  },
  'Déficience visuelle': {
    'label-th': 'labelthvis',
    'acc-key': 'avis',
    'desc-th': 'descthvis'
  },
  'Déficience auditive': {
    'label-th': 'labelthaud',
    'acc-key': 'aaud',
    'desc-th': 'descthaud'
  },
  'Déficience mentale': {
    'label-th': 'labelthmen',
    'acc-key': 'amen',
    'desc-th': 'descthmen'
  }
};

export const SelectedFeatureDetails = ({isMobile, selectedFeature, layer_id, getFeatureInfoAttrs}) => {
  /**
     * composant for check if feature is of type Point or Line
     */
  const [loadData, setLoadData] = useState(false);
  const [typeGeo, setTypeGeo] = useState(null);
  const [apiFeature, setApiFeature] = useState(null);
  useEffect(() => {
    setLoadData(true);
    callGetFeatureJson(layer_id, selectedFeature.properties.fid).then(
      result => {
        const {geometry} = result;
        setApiFeature(result);
        setTypeGeo(geometry.type);
      }
    ).catch(error => {
      console.log('error', error);
    });
    setLoadData(false);
    return () => {
      setTypeGeo(null);
    };
  }, [selectedFeature]);
  
  const renderFeatureDetails = () => {
    return (
      <>
        { typeGeo.includes('LineString') && (
          <SelectedFeatureLineDetails 
            isMobile={isMobile} 
            profilAttributeAccessMapping={profilAttributeAccessMapping}
            apiFeature={apiFeature}
            layerID={layer_id}
            getFeatureInfoAttrs={getFeatureInfoAttrs}
          />
        )}
        { typeGeo.includes('Point') && (
          <SelectedFeaturePointDetails  
            isMobile={isMobile} 
            profilAttributeAccessMapping={profilAttributeAccessMapping}
            apiFeature={apiFeature}
            layerID={layer_id}
            getFeatureInfoAttrs={getFeatureInfoAttrs}
          />
        )}
      </>
    );
  };
  return (
    <>
      {(loadData || typeGeo === null) && (
        <Box sx={{display: 'flex', width: '100%', justifyContent: 'center'}}>
          <CircularProgress color='secondary'/>
        </Box>
      )}
      {!loadData && typeGeo !== null && (renderFeatureDetails())}
    </>
  );
};